import React from "react";
import { Button, ListItem } from "@mui/material";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

export interface DefaultUploadFilesProps {
    setFilesUpload: (file: File[]) => void,
    files: File[],
}

export default function DefaultUploadFiles({ props }: { props: DefaultUploadFilesProps }) {
    const [selectedFiles, setSelectedFiles] = React.useState<File[]>(props.files);
    const handleChange = (selectorFiles: FileList) => {
        let arr = Array.from(selectorFiles);
        var joined = selectedFiles.concat(arr);
        setSelectedFiles(joined);

        if (props.setFilesUpload !== undefined)
            props.setFilesUpload(joined);
    };
    const removeFile = (file: File) => {

        var newFiles = selectedFiles.filter(function (fileFilter) {
            return fileFilter !== file
        });

        setSelectedFiles(newFiles);
        if (props.setFilesUpload !== undefined)
            props.setFilesUpload(newFiles);
    };
    return (
        <React.Fragment>
            <input
                accept="application/pdf"
                style={{ display: 'none' }}
                id="raised-button-file"
                multiple
                type="file"
                onChange={(e: any) => handleChange(e.target.files)}
            />
            <label htmlFor="raised-button-file">
                <Button className="btn-choose" variant="contained" fullWidth
                    component="span" >
                    Selecionar Arquivos
                </Button>
            </label>

            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {selectedFiles?.map((file, index) => (

                    <ListItem
                        key={file.name}
                        secondaryAction={
                            <IconButton edge="end" aria-label="comments" onClick={() => {
                                removeFile(file);
                            }}>
                                <DeleteIcon />
                            </IconButton>
                        }
                        disablePadding
                    >
                        <ListItemButton role={undefined} dense>
                            <ListItemText id={file.name} primary={`${file.name}`} />
                        </ListItemButton>
                    </ListItem>
                ))}

            </List>
        </React.Fragment>

    );
}